import { render, staticRenderFns } from "./event.vue?vue&type=template&id=41f5d13f&scoped=true"
import script from "./event.vue?vue&type=script&lang=js"
export * from "./event.vue?vue&type=script&lang=js"
import style0 from "./event.vue?vue&type=style&index=0&id=41f5d13f&prod&lang=scss&scoped=true"
import style1 from "./event.vue?vue&type=style&index=1&id=41f5d13f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f5d13f",
  null
  
)

export default component.exports